import { createPermissions } from '@portal/shared/helpers';
import { UserRoles } from '@portal/shared/auth/authorization';

export const reportTemplatesPermissions = createPermissions({
  list: {
    read: [UserRoles.VerifoneAdmin, UserRoles.MerchantAdmin, UserRoles.AcquirerAdmin,],
  },
  create: {
    read: [UserRoles.VerifoneAdmin, UserRoles.MerchantAdmin, UserRoles.AcquirerAdmin,],
  },
  edit: {
    read: [UserRoles.VerifoneAdmin, UserRoles.MerchantAdmin, UserRoles.AcquirerAdmin,],
  },
  manageTemplate: {
    read: [UserRoles.VerifoneAdmin, UserRoles.MerchantAdmin, UserRoles.AcquirerAdmin,],
  },
});
